<hfc-standalone-modal-container>
  <div class="container" [class.isSubmitting]="isSubmitting">
    <div class="heading">
      <i class="material-icons" routerLink="/login">arrow_back</i>

      <h2>We’ve sent you a code</h2>
    </div>

    <div class="hint">
      Please enter the 6 digit code we have sent to your mobile number ending with {{ user?.lastMobileDigits }}.
    </div>

    <form>
      <hfc-code-input
        [invalid]="isInputRed"
        [disabled]="isSubmitting"
        (codeEnter)="onCodeEntered($event)"
      ></hfc-code-input>
    </form>
  </div>

  <hfc-spinner *ngIf="isSubmitting"></hfc-spinner>

  <ng-container *ngIf="!isSubmitting">
    <p class="hint" [class.red]="isRequestNewCodeRed">
      <ng-container *ngIf="!canRequestNewCode; else canRequestTpl">
        Didn’t get a code? You can request a new one in {{ remainingSeconds }}s.
      </ng-container>

      <ng-template #canRequestTpl>
        <div>
          <span
            (click)="onRequestNewClicked()"
            class="link-button"
            [class.loading]="isRequestNewCodeLoading"
            *ngIf="!isRequestNewCodeLoading"
          >Request new code</span
          >
        </div>
      </ng-template>
    </p>

    <p *ngIf="requestMessage" [class.red]="isRequestNewCodeRed">{{ requestMessage }}</p>
  </ng-container>
</hfc-standalone-modal-container>
